import { render, staticRenderFns } from "./high-building.vue?vue&type=template&id=08468024&scoped=true&"
import script from "./high-building.vue?vue&type=script&lang=js&"
export * from "./high-building.vue?vue&type=script&lang=js&"
import style0 from "./high-building.vue?vue&type=style&index=0&id=08468024&prod&lang=less&module=true&"
import style1 from "./high-building.vue?vue&type=style&index=1&id=08468024&prod&lang=less&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "08468024",
  null
  
)

export default component.exports